<template>
	<v-hover>
		<div slot-scope="{ hover }" class="item" :class="{ edit: isEdit, 'allow-edit': allowEdit }" @click="clickItem">
			<div :class="{ 'item-text': true }">
				<table style="width: 100%">
					<tr>
						<td v-show="!isEdit" style="width: 1px;">
							<v-btn :class="{ 'item-btn': true, disabled: true }" fab small>
								<v-icon class="icon">keyboard_arrow_right</v-icon>
							</v-btn>
						</td>
						<td class="text-xs-left">
							<div v-show="!isEdit">
								{{ form.item.item }}
								<traffic-light-rank-indicator v-show="form.isRanked" />
							</div>
							<div v-show="isEdit" class="edit-box">
								<v-textarea ref="textfield" v-model="form.item.item" placeholder="New Discussion Point" background-color="#fff" required auto-grow rows="3" full-width :error-messages="itemErrors"></v-textarea>

								<table style="width: 100%">
									<tr>
										<td>
											<v-switch v-model="form.isRanked" style="margin:0; padding: 0;" label="This discussion point requires rating"></v-switch>
											<div class="traffic-light-helper-message">
												<span>using Traffic Light Rating</span>
											</div>
										</td>
										<td style="width: 250px;" class="text-xs-right">
											<div v-show="isEdit">
												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-btn small v-on="on" @click.stop="cancelEdit">Cancel</v-btn>
													</template>
													<span>Cancel Edit</span>
												</v-tooltip>

												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-btn small color="primary" v-on="on" @click.stop="saveChanges">Save</v-btn>
													</template>
													<span>Save Changes</span>
												</v-tooltip>
											</div>
										</td>
									</tr>
								</table>
							</div>
						</td>

						<v-expand-transition>
							<td v-if="hover" v-show="!isEdit && allowEdit" style="width: 150px;">
								<v-btn small class="error remove-btn" @click.stop="removeItemClick">Remove</v-btn>
							</td>
						</v-expand-transition>
					</tr>
				</table>
			</div>
			<v-divider></v-divider>
		</div>
	</v-hover>
</template>

<script>
	import TrafficLightRankIndicator from '@/components/TrafficLightRankIndicator';
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		props: {
			item: {
				type: Object,
				required: true
			},
			allowEdit: {
				type: Boolean,
				required: false,
				default: true
			}
		},
		components: {
			TrafficLightRankIndicator
		},
		data() {
			return {
				isEdit: false,
				form: {
					item: this.item,
					isRanked: this.item.rankType === 1
				},
				original: null
			};
		},
		created() {
			this.original = Object.assign({}, this.item);
			if (this.isEmpty) {
				this.setIsEdit(true);
				this.$nextTick(() => this.$refs.textfield.focus());
			}
		},
		computed: {
			isEmpty() {
				return this.form.item.item == null;
			},
			itemErrors() {
				const errors = [];
				if (!this.$v.form.item.$dirty) return errors;
				!this.$v.form.item.required && errors.push('Discussion Point is required.');
				return errors;
			}
		},
		mixins: [validationMixin],
		validations: {
			form: {
				item: {
					item: { required }
				}
			}
		},
		methods: {
			clickItem() {
				if (this.allowEdit) {
					this.setIsEdit(true);
					this.$nextTick(() => this.$refs.textfield.focus());
				}
			},
			removeItemClick() {
				if (confirm('Are you sure you wish to remove this item?')) {
					this.$emit('onItemRemoved', this.form.item);
				}
			},
			cancelEdit() {
				this.form.item = this.original;
				this.setIsEdit(false);

				if (this.isEmpty) {
					this.$emit('onItemRemoved', this.form.item);
				}
			},
			saveChanges() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					this.setIsEdit(false);
					this.form.item.rankType = this.form.isRanked ? 1 : 0;
					this.$emit('onItemChanged', this.form.item);
					this.original = this.form.item;
				}
			},
			setIsEdit(val) {
				this.isEdit = val;
				this.$emit('onSetIsEdit', val);
			}
		}
	};
</script>

<style scoped>
	.item.allow-edit {
		cursor: pointer;
	}
	.item.allow-edit.edit {
		cursor: text;
		/* border-top: solid 1px blue;
			    border-bottom: solid 1px blue; */
		background-color: #e3f2fd;
	}
	.edit-box {
		margin-top: 10px;
	}
	.item:not(.edit).allow-edit:hover {
		background-color: rgba(0, 0, 0, 0.04);
	}
	.item-icon .icon {
		font-size: 14px;
	}
	.remove-btn {
		margin: 0;
		padding: 0;
	}
	.traffic-light-helper-message {
		margin-top: -26px;
		margin-left: 45px;
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px;
		font-style: italic;
	}
</style>
